import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'
import { format, parse } from 'date-fns'
import React from 'react'
import es from 'date-fns/locale/es'
import { registerLocale } from 'react-datepicker'
registerLocale('es', es)

export default function DateHourCell({ value = '' }) {
  const onlyDateString = value.split(' ')
  const date = parse(onlyDateString[0], 'dd-MM-yyyy', new Date())
  const dateH = new Date(`${format(date, 'yyyy-MM-dd')} ${onlyDateString[1]} `)
  const finalDate = format(dateH, "dd-MM-yyyy '/' hh:mm:ss")

  return (
    <Text variant={'body2'} textAlign="center" textTransform="capitalize">
      {finalDate}
    </Text>
  )
}

DateHourCell.propTypes = {
  value: PropTypes.string,
}
